<template>
  <div class="concern-keywords-container">
    <div class="row concern-keywords-header">
      <div class="row concern-keywords-tabs">
          <div
            class="tab-item" 
            :class="{'tab-item-active': item === selectedOptionTab}" 
            v-for="(item, index) in tabs" 
            :key="index"
            @click="onTabClick(item, index)"
          >
          <span class="tab-item-title" v-if="item.length<=9">{{item}}</span>
          <el-popover
            placement="bottom-start"
            trigger="hover"
            :visible-arrow="false"
            popper-class="tips"
          >
            <span class="delete-hover-title" style="position:absolute,top:100px,left:5px,color:#000">
              {{item}}
            </span>
            <div slot="reference" class="delete-hover">
             <span class="tab-item-title" v-if="item.length>9">{{item}}</span>
            </div>
          </el-popover>
          </div>
      </div>
      <div class="title-button" v-if="showHeaderBtn" @click="onChangeTabsShow">
        <img class="arrow-img" v-if="showAllTabs" src="../../assets/img/up-arrow1.svg" />
        <img class="arrow-img" v-else src="../../assets/img/down-arrow1.svg" />
      </div>
    </div>
    <div class="news-list-content">
      <div class="news-list-detail" v-loading="isLoading">
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
          <news-list-item v-for="(item, index) in resultData" :key="index" :data="item" :index="index"></news-list-item>
        </div>
      </div>
      <div class="loading" v-if="pageItems && resultData.length"><div class="loading-word">加载中...</div></div>
      <div class="loading" v-if="!pageItems"><div class="loading-word">没有更多了</div></div>
      <div class="no-data-container" v-if="!isLoading && !resultData.length">
        <no-data v-if="tabs.length && !isLoading && !resultData.length"></no-data>
        <img v-if="showAddKeyWords && !tabs.length" class="empty-img" src="../../assets/img/empty-img.svg" alt="">
        <div v-if="showAddKeyWords && !tabs.length" class="empty-word">
          <div>尊敬的用户，您当前尚未关注任何关键词，可以通过以下方式管理关注关键词：</div>
          <div>1、点击“<span @click="manageConcerns" class="empty-word-btn">管理关注内容</span>”，添加想要关注的关键词</div>
        </div>
      </div>
    </div>
    <BackTop></BackTop>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import NewsListItem from '@/components/concern/ConcernKeywordsNewsListItem';
import NoData from '@/components/common/NoData';
import Mark from 'mark.js';
import BackTop from '@/components/common/BackTop';

export default {
  data() {
    return {
      showAddKeyWords: false,
      headerTagElementHeight: 0,
      headerTagElement: null,
      showAllTabs: true,
      showHeaderBtn: false,
      keywordElement: null,
      tabs: [],
      selectedOptionTab: '',
      earliestNewsId: -1,
      earliestDateNum: -1,
      pageSize: 20,
      isLoading: false,
      resultData: [],
      pageItems: [],
      busy: false,
      timer: null
    };
  },
  methods: {
    manageConcerns() {
      this.$router.push({
        path: '/follow',
        query: {
          type: 'keywords'
        }
      });
    },
    onChangeTabsShow() {
      this.showAllTabs = !this.showAllTabs;
      if (!this.showAllTabs) {
        this.headerTagElement.style.height = '44px';
        this.headerTagElement.style.overflow = 'hidden';
        this.headerTagElement.style.transition = 'all .3s ease-in';
      } else {
        this.headerTagElement.style.height = `${this.headerTagElementHeight}px`;
        this.headerTagElement.style.overflow = 'auto';
        this.headerTagElement.style.transition = 'all .3s ease-in';
      }
    },
    onTabClick(item) {
      this.selectedOptionTab = item;
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.resultData = [];
      this.pageItems = [];
      this.getKeywordList();
    },
    getMonitorKeywordList() {
      QuestionQuery.getMonitorKeywordList(this.username).then(res => {
        this.tabs = res.map(item => item.keyword);
        this.showAddKeyWords = this.tabs.length === 0;
        this.selectedOptionTab = this.tabs[0];
        this.$nextTick(() => {
          this.headerTagElement = document.querySelector('.concern-keywords-header');
          this.headerTagElementHeight = document.querySelector('.concern-keywords-header').clientHeight;
          if (this.headerTagElementHeight > 61) {
            this.showHeaderBtn = true;
            this.headerTagElement.style.height = '44px';
            this.headerTagElement.style.overflow = 'hidden';
            this.showAllTabs = false;
          } else {
            this.showHeaderBtn = false;
            this.headerTagElement.style.height = '44px';
            this.headerTagElement.style.overflow = 'hidden';
          }
        });
        if (this.tabs.length) {
          this.getKeywordList();
        }
      });
    },
    getKeywordList() {
      const params = {
        user: this.username,
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1,
        page_size: this.pageSize,
        keyword: this.selectedOptionTab
      };
      this.isLoading = true;
      QuestionQuery.getKeywordList(params).then(result => {
        this.isLoading = false;
        this.pageItems = result.pageItems;
        this.totalCount = result.totalCount;
        if (result.pageItems.length) {
          this.highlight = result.highlight;
          this.earliestNewsId = this.pageItems[this.pageItems.length - 1].newsId;
          this.earliestDateNum = this.pageItems[this.pageItems.length - 1].dateNum;
          this.resultData = this.resultData.concat(result.pageItems);
          this.busy = false;
        } else {
          this.busy = true;
        }
      },
      () => {
        this.isLoading = false;
      });
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.pageItems.length) {
        this.timer = setTimeout(() => {
          this.getKeywordList(true);
        }, 500);
      }
    }
  },
  updated() {
    const instance = new Mark(document.querySelectorAll('.news-item-container-title-left'));
    const instanceContent = new Mark(document.querySelectorAll('.summary-content'));
    if (this.highlight && this.highlight.title.length) {
      instance.mark(this.highlight.title || [], {
        element: 'span',
        className: 'highlight'
      });
    }
    if (this.highlight && this.highlight.content.length) {
      instanceContent.mark(this.highlight.content || [], {
        element: 'span',
        className: 'highlight'
      });
    }
  },
  components: {
    NewsListItem,
    NoData,
    BackTop
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getMonitorKeywordList();
  }
};
</script>

<style  lang="scss" scoped>
.loading {
  padding: 12px 0;
  margin: 0 auto;
  height: 45px;
  width: 772px;
  color: #666666;
  text-align: center;
}
.no-data-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 188px);
  background-color: #ffffff;
  .no-data {
    color: #747990;
  }
  .empty-img {
    position: absolute;
    top: 180px;
    left: 50%;
    transform: translateX(-50%);
  }
  .empty-word {
    position: absolute;
    top: 350px;
    left: 50%;
    transform: translateX(-50%);
    color: #747990;
    font-size: 14px;
    &-btn {
      color: #45a8cc;
      cursor: pointer;
    }
  }
}
  .concern-keywords-container {
    width: 100%;
    .concern-keywords-header {
      padding: 12px 24px 0;
      min-height: 44px;
      background-color: #ffffff;
      box-shadow: inset 0px -1px 0px 0px#f7f7fa;
      .concern-keywords-tabs {
        width: 1120px;
        height: 100%;
        flex-wrap: wrap;
        font-size: 14px;
        .tab-item-title {
          display: inline-block;
          max-width: 126px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .tab-item {
          margin-right: 32px;
          margin-bottom: 10px;
          color: #747990;
          cursor: pointer;
        }
        .tab-item-active {
          position: relative;
          color: #171f46;
        }
        .tab-item-active::after {
          content: "";
          position: absolute;
          top: 25px;
          left: 50%;
          transform: translateX(-50%);
          width: 14px;
          height: 3px;
          background-color: #171f46;
        }
      }
      .title-button {
        width: 24px;
        height: 24px;
        line-height: 24px;
        margin-top: -2px;
        text-align: center;
        background-color: rgba(0, 11, 92, 0.03);
        border-radius: 2px;
        cursor: pointer;
        &:hover {
          background-image: linear-gradient(
              rgba(0, 0, 0, 0.1),
              rgba(0, 0, 0, 0.1)
            ),
            linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
          background-blend-mode: normal, normal;
        }
        &:active {
          background-color: #e6eeff;
        }
        .arrow-img {
          margin-top: -2px;
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
      }
    }
    .news-list-content {
      padding: 0 24px;
      background-color: #ffffff;
    }
  }
</style>
<style lang="scss">
  .el-popover.el-popper.tips {
    min-width: 300px;
    height: 4px;
    color: transparent;
    border: none;
    font-size: 12px;
    background-color: transparent;
    box-shadow: none;
    /deep/ .delete-hover-title {
      position: relative;
      top: -20px;
      left: -15px;
      min-width: 500px;
      height: 26px;
      background-color: #3d414f;
      border-radius: 2px;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 18px;
      letter-spacing: 0px;
      color: #ffffff;
      padding: 4px;
    }
  }
</style>
